module.exports = __webpack_public_path__ + "media/burial-document_1600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/burial-document_1600.jpg
// module id = 13
// module chunks = 0